import ButtonIcon from './button-icon';

export default ButtonIcon;
